import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../app.store';
import type { AuthInitialState, VerifyPayload } from './auth.types';

const initialState: AuthInitialState = {
  verifiedInfo: JSON.parse(localStorage.getItem('verifiedInfo') || 'null'),
  access_token: localStorage.getItem('access_token') || undefined,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    verifyUser: (state, { payload }: { payload: VerifyPayload }) => {
      state.verifiedInfo = payload?.user;
      state.access_token = payload?.access_token;
    },
    updateVerifiedInfo: (state, { payload }: { payload: any }) => {
      state.verifiedInfo = { ...state.verifiedInfo, ...payload };
      localStorage.setItem('verifiedInfo', JSON.stringify(state.verifiedInfo));
    },
    userLoggedOut: (state) => {
      state.access_token = undefined;
      state.verifiedInfo = undefined;
      localStorage.clear();
    },
  },
});

export const { userLoggedOut, verifyUser, updateVerifiedInfo } = authSlice.actions;
export const authReducer = authSlice.reducer;

/* ------ Selectors ------ */
export const selectAuth = (state: RootState) => state.auth;
